import {useTheme} from "styled-components";
import {capitalized, labelHelper, urlHelper} from "helpers/themeHelpers";
import {isClientSide} from "helpers/globalHelpers";
import {ICategoryLiteAsset} from "models/Assets/ICategoryAsset";
import {ICityLiteAsset} from "models/Assets/ICityAsset";
import {INeighborhoodLiteAsset} from "models/Assets/INeighborhoodAsset";
import {ICpOption} from "models/Assets/IDynamicAttributes";
import {parseUTMs} from "GTMs/parseUTMs";
import {useSsoContext} from "contexts/authSSOContext";
import {iBasicInfoItem} from "../screens/PostView/_private/Api/types";

export const useGtmDefaultData = () => {
    if (!isClientSide()) return;
    const {locale, country, device, memberData} = useTheme();
    const { isLoggedInSso } = useSsoContext();

    const {utm_medium, utm_campaign, utm_source} = parseUTMs();
    // @ts-ignore
    window.gtmDefaultParams = {
        LoggedIn: isLoggedInSso || "empty",
        Language: locale || "empty",
        Country: country || "empty",
        Device: device || "empty",
        MemberID: memberData?.id || "empty",
        Version: process.env.NEXT_PUBLIC_APP_VERSION || "empty",
        //@todo revert this after experiment with Adey for Google Analytics UTM checking
        // cMedium: utm_medium,
        // cName: utm_campaign,
        // cSource: utm_source,
    };
};

interface IData {
    category?: ICategoryLiteAsset;
    subCategory?: ICategoryLiteAsset;
    city?: ICityLiteAsset;
    neighborhoods?: INeighborhoodLiteAsset[];
    selectedCpsOptions?: ICpOption[] | iBasicInfoItem[];
}

export const cleanGtmExtraData = () => {
    setGtmExtraData(null);
};
// export const getAbbrFromUrl = () => {
//     const url = isBrowser() && window.location.href;
//     const regex = /https?:\/\/(.+?)\./;
//     const match = url.match(regex);
//     let result;
//     if (match && match[1] === "shobiddak") {
//         result = 'ps';
//     } else {
//         result = match ? (match[1].length === 2 && match[1]) : null;
//     }
//     return result;
// };

export const setGtmExtraData = (data: IData = null) => {
    const {selectedCpsOptions, category, subCategory, city, neighborhoods} =
    data || {};
    const extraData = {
        CP1: labelHelper(selectedCpsOptions?.[0], "en") || "empty",
        CP2: labelHelper(selectedCpsOptions?.[1], "en") || "empty",
        CP3: labelHelper(selectedCpsOptions?.[2], "en") || "empty",
        CP4: labelHelper(selectedCpsOptions?.[3], "en") || "empty",
        Category: category?.reporting_name || "empty",
        City: capitalized(urlHelper(city, "en")).replaceAll("-", " ") || "empty",
        Neighborhood: labelHelper(neighborhoods?.[0], "en") || "empty",
        SubCategory: subCategory?.reporting_name || "empty",
    };
    // @ts-ignore
    window.gtmExtraData = extraData;
    return extraData;
};
